import React from 'react';

/**
 * @memberof module:components
 * @function EstimateBadge
 * @description Small amber pill flagging an estimated charge line/section. Mirrors the inline
 * badge shipped in the RFQ offer breakdown (ViewDetailsFooter). Rendered only when the row/section
 * is an estimate; LOW confidence adds a "confirm via RFQ" hint per the port-charges design.
 *
 * @param {Object} props
 * @param {boolean} [props.show=true] - render nothing when false (keeps call sites terse)
 * @param {('HIGH'|'MED'|'LOW')} [props.confidence] - drives the LOW-confidence hint
 * @param {string} [props.label='EST.'] - badge text
 */
const BADGE_STYLE = {
  marginLeft: 6,
  fontSize: 10,
  fontWeight: 700,
  color: '#b26a00',
  background: '#fff3e0',
  border: '1px solid #ffe0b2',
  borderRadius: 3,
  padding: '0 5px',
  verticalAlign: 'middle',
  whiteSpace: 'nowrap',
};

const HINT_STYLE = {
  marginLeft: 6,
  fontSize: 10,
  fontWeight: 600,
  color: '#8a5a00',
  fontStyle: 'italic',
};

export const EstimateBadge = ({ show = true, confidence, label = 'EST.' }) => {
  if (!show) return null;
  return (
    <>
      <span style={BADGE_STYLE}>{label}</span>
      {confidence === 'LOW' ? <span style={HINT_STYLE}>confirm via RFQ</span> : null}
    </>
  );
};

export default EstimateBadge;
